import { get as e } from "react-hook-form";
//#region src/utils/form-errors.ts
var t = (e) => typeof e == "object" && !!e && "instancePath" in e && "message" in e && typeof e.instancePath == "string" && typeof e.message == "string", n = (e) => t(e) ? [e] : typeof e != "object" || !e ? [] : Object.values(e).flatMap(n);
function r(e) {
	return !e || e === "/" ? "root" : e.split("/").slice(1).map((e) => /^\d+$/.test(e) ? `[${e}]` : e).reduce((e, t) => t.startsWith("[") ? e + t : e ? `${e} → ${t}` : t, "");
}
function i(e) {
	return `${r(e.instancePath)}: ${e.message}`;
}
var a = (t, n) => {
	let r = e(t, n) || {};
	return Object.keys(r).length > 0;
};
//#endregion
export { a as i, i as n, r, n as t };

//# sourceMappingURL=form-errors-Cclg0hCD.js.map